import port1 from '../img/portImages/port7.jpg';
import port2 from '../img/portImages/port6.jpg';

const portfolios = [
    {
        id: 1,
        category: 'GM',
        link1: 'https://gabrielmartin.yt',
        icon1: 'Open landing',
        image: port1,
        title: 'Gabriel Martin Landing',
        description: 'Descubre la educación financiera con Gabriel Martin. Aprende a gestionar tu dinero e invertir.',
        ogTitle: 'Gabriel Martin: Inicio',
        ogDescription: 'Descubre la educación financiera con Gabriel Martin. Aprende a gestionar tu dinero e invertir.',
        ogImage: 'https://gabrielmartin.yt/og/gmyt-default.png',
        domain: 'gabrielmartin.yt',
        tech: 'GM, Financial education, Landing page'
    },
    {
        id: 2,
        category: 'GM',
        link1: 'https://ameba.gabrielmartin.yt',
        icon1: 'Open AMEBA',
        image: port2,
        title: 'AMEBA',
        description: 'Herramienta para seguimiento de portfolio en Argentina. Registro de CEDEARs y acciones locales, con rendimientos en pesos y dólares.',
        ogTitle: 'AMEBA | Seguimiento de portfolio y CEDEARs en Argentina',
        ogDescription: 'Herramienta para seguimiento de portfolio en Argentina. Registro de CEDEARs y acciones locales, con rendimientos en pesos y dólares.',
        ogImage: 'https://ameba.gabrielmartin.yt/images/portada.png',
        domain: 'ameba.gabrielmartin.yt',
        tech: 'GM, AMEBA, Investing, Portfolio tracking'
    }
]

export default portfolios;
